import React from 'react';
import TextField from './TextField';

const PasswordField = (props) => {
  return (
    <TextField
      {...props}
      type="password"
    />
  );
};

export default PasswordField;
